import { render, staticRenderFns } from "./allApp.vue?vue&type=template&id=1cd4fc56&scoped=true&"
import script from "./allApp.vue?vue&type=script&lang=js&"
export * from "./allApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd4fc56",
  null
  
)

export default component.exports